import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';

import { updatePaymentModel } from '../../api';

interface IProps {
  calculationId: string;
}

export const useUpdateCalculationPaymentModel = ({ calculationId }: IProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, isLoading } = useMutation(updatePaymentModel, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE);
      queryClient.invalidateQueries([QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, calculationId]);
      successToast(t('Calculation saved successfully.'));
    },
    onError: () => errorToast(),
  });

  return {
    isLoading,
    mutate,
  };
};
